import React from 'react';
import BaseDialog from '../../components/BaseDialog';
import useDutiesWeeksService from '../../api/services/DutiesWeeksService';

function DeleteDialog({ open, onClose, dutiesWeekId, onSuccess }) {
    const { deleteDutiesWeek } = useDutiesWeeksService();

    const handleDelete = () => {
        deleteDutiesWeek(dutiesWeekId, () => {
            if (onSuccess) onSuccess();
            onClose();
        });
    };

    return (
        <BaseDialog
            open={open}
            onClose={onClose}
            title="Do you want to delete the specified duties week?"
            confirmButtonText="Delete"
            cancelButtonText="Cancel"
            onConfirm={handleDelete}
            confirmButtonColor="error"
            cancelButtonColor="secondary"
        />
    );
}

export default DeleteDialog;

